



















import { Location } from 'vue-router'
import { computed, defineComponent } from '@vue/composition-api'
import { useAuth } from '@/composable/useAuth'
import Scrollable from '@/components/layouts/Scrollable.vue'

export default defineComponent({
  name: 'NotFound',

  components: { Scrollable },

  setup() {
    const { accessToken } = useAuth()

    const redirectTo = computed((ctx): Location => {
      if (accessToken.value && ctx.$route.params.organisation && ctx.$route.params.store) {
        return { name: 'dashboard', params: { ...ctx.$route.params } }
      }
      return { name: 'login' }
    })

    return {
      redirectTo
    }
  }
})
